import { FC, useMemo } from "react"
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import { TextAlignment, WafflesThemes } from "@app/shared/waffles/exports";
import { TopCountiesByGapData } from "../interfaces";

interface TopCountiesTableData {
  county: string;
  numberOfGaps: string;
  numberOfProjects: string;
  [wafflesKeyColumnName]: string;
}

const columnConfig: ColumnConfig = {
  "county": {
    alignment: TextAlignment.Left,
    displayText: "County",
    noSort: true,
    testId: "county",
  },
  "numberOfGaps": {
    alignment: TextAlignment.Right,
    displayText: "Number of Gaps",
    noSort: true,
    testId: "number-of-gaps",
  },
  "numberOfProjects": {
    alignment: TextAlignment.Right,
    displayText: "Number of Projects",
    noSort: true,
    testId: "number-of-projects",
  }
};

interface TopCountiesByGapTableProps {
  tableData: TopCountiesByGapData[];
}

const TopCountiesByGapTable: FC<TopCountiesByGapTableProps> = (props: TopCountiesByGapTableProps) => {

  /* eslint-disable sort-keys */
  const tableRows: TopCountiesTableData[] = useMemo(() => {
    return (props.tableData || []).map((row) => {
      return {
        county: row.countyName,
        numberOfGaps: row.gaps.toLocaleString(),
        numberOfProjects: row.projects.toLocaleString(),
        [wafflesKeyColumnName]: row.countyName,
      };
    })
  }, [props.tableData]);
  /* eslint-enable */

  return (
    <div className="qes-dashboard-tile__table county">
      <Waffles<TopCountiesTableData>
        columns={columnConfig}
        data={tableRows}
        disableStickyHeader={true}
        fullWidth={true}
        keyColumns={["county"]}
        loading={!props.tableData}
        testId="top-counties-by-gap"
        theme={WafflesThemes.Simple}
      />
    </div>
  )
}

export default TopCountiesByGapTable;
